<div class="white-box border-radius p-4 mt-4 mx-4">
	<h5 class="mb-3">{{ 'studies.inventory_report_title' | translate }}</h5>
	<sct-custom-table
		[columnsConfig]="listingColumns"
		[data]="inventoryData"
		[config]="tableConfig"
	></sct-custom-table>
</div>

<app-modal #locationModal [title]="'g.locations' | translate" size="lg" [hasConfirmButton]="false">
	<app-mapbox-search
		*ngIf="selectedLocation && isShownMap"
		class="border-radius main-blue-border"
		[latitude]="sitesService.defaultMapLocation.latitude"
		[longitude]="sitesService.defaultMapLocation.longitude"
		zoom="3.5"
		dotsType="mix"
		[dots]="selectedLocation"
		[showPopup]="false"
	></app-mapbox-search>
</app-modal>
